import React from 'react';
import { Star, Quote } from 'lucide-react';
export function TestimoniosSection() {
  const testimonials = [{
    quote: 'Me permitió organizar toda la materia sin improvisar. Ahora tengo estructura para todo el año y mis alumnos trabajan proyectos reales.',
    name: 'Mariana López',
    role: 'Profesora de Proyecto Organizacional, 42 años'
  }, {
    quote: 'Ahora puedo trabajar proyectos organizacionales con mucha más claridad. El diagnóstico FODA y la planificación están perfectamente explicados.',
    name: 'Gustavo Peralta',
    role: 'Docente de Gestión y Organizaciones, 38 años'
  }, {
    quote: 'Me dio una estructura completa para todo el año. Los módulos están organizados de forma progresiva y mis estudiantes presentaron proyectos de nivel profesional.',
    name: 'Silvina Acosta',
    role: 'Profesora de Proyecto Organizacional, 45 años'
  }, {
    quote: 'El banco de proyectos organizacionales me ahorró semanas de trabajo. Cada proyecto está listo para aplicar en el aula.',
    name: 'Fernando Ruiz',
    role: 'Docente de Gestión, 35 años'
  }, {
    quote: 'Como estudiante de profesorado, este kit me dio herramientas que no encontré en ningún otro lado. Lo recomiendo a todos mis compañeros.',
    name: 'Camila Herrera',
    role: 'Estudiante de profesorado, 26 años'
  }];
  return <section id="testimonios" className="py-5 sm:py-16 bg-[#0f172a]" data-id="element-213">
      <div className="max-w-6xl mx-auto px-3 sm:px-6" data-id="element-214">
        <div className="text-center mb-5 sm:mb-12" data-id="element-215">
          <h2 className="text-lg sm:text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-216">
            Testimonios de docentes
          </h2>
          <p className="text-gray-400 text-xs sm:text-base" data-id="element-217">
            Lo que dicen quienes ya están usando el kit en sus aulas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6" data-id="element-218">
          {testimonials.map((t, i) => <div key={i} className="bg-[#1e293b] p-3.5 sm:p-6 rounded-xl border border-gray-700 relative hover:border-[#fbbf24]/50 transition-colors" data-id="element-219">
              <Quote className="absolute top-3 right-3 text-gray-600 h-5 w-5 opacity-50" data-id="element-220" />

              <div className="flex gap-0.5 mb-2" data-id="element-221">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-222" />)}
              </div>

              <p className="text-gray-200 text-xs sm:text-base italic mb-3 leading-relaxed" data-id="element-223">
                "{t.quote}"
              </p>

              <div className="mt-auto" data-id="element-224">
                <p className="text-white font-bold text-xs sm:text-sm" data-id="element-225">
                  — {t.name}
                </p>
                <p className="text-gray-400 text-[10px] sm:text-xs" data-id="element-226">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}